/**
 * Promociones vigentes (etapa 1: hardcodeadas).
 *
 * Los campos siguen la forma acordada y se corresponden con las columnas del
 * documento de home:
 *   marca        {string}   MARCA/CATEGORÍA
 *   titulo       {string}   DESTACADO — la mecánica en corto
 *   descripcion  {string}   BAJADA — una línea de contexto
 *   condiciones  {string}   Texto de "Ver condiciones"
 *   imagen       {string}   Base de la foto optimizada, sin ancho ni extensión
 *                           (ver src/utils/responsiveImage.js)
 *   destacada    {boolean}  Jerarquía visual: las destacadas van más grandes
 *   activa       {boolean}  `false` la saca del sitio sin borrar el dato
 *   prioridad    {number}   Orden ascendente
 *
 * Cuando las promociones salgan del backend, esta lista se reemplaza por la
 * query manteniendo la misma forma.
 */
export const promotions = [
	{
		marca: "Küül 60 ml",
		titulo: "12+12 de Regalo*",
		descripcion: "Pomos 60 g · sin descuentos habituales",
		condiciones: "Pomos Küül de 60 ml: 12+12. No se aplican los descuentos habituales. Sujeto a vigencia y estado de cuenta.",
		imagen: "/assets/promos/kuul-60ml",
		destacada: true,
		activa: true,
		prioridad: 1
	},
	{
		marca: "Hidracolor 90 g",
		titulo: "12+1 de regalo / 12+2 de Regalo*",
		descripcion: "Según escala vigente",
		condiciones: "Pomos Hidracolor de 90 g: 12+1 o 12+2 según la escala vigente y las compras del mes anterior. La escala se calcula por marca. Compra mínima para utilizar el beneficio: 1 docena. Sujeto a vigencia y estado de cuenta.",
		imagen: "/assets/promos/hidracolor-90g",
		destacada: true,
		activa: true,
		prioridad: 2
	},
	{
		marca: "Herramientas eléctricas",
		titulo: "6+1 de Regalo*",
		descripcion: "Códigos combinables",
		condiciones: "6+1 en herramientas eléctricas. Se pueden combinar diferentes códigos. La unidad sin cargo corresponde al artículo de menor valor. Sujeto a vigencia y estado de cuenta.",
		imagen: "/assets/promos/herramientas-electricas",
		destacada: false,
		activa: true,
		prioridad: 3
	}
];

/** Aclaración común al pie de las tarjetas (el asterisco de los destacados). */
export const PROMOTIONS_FOOTNOTE = "Promociones sujetas a vigencia, estado de cuenta y condiciones comerciales.";

/** Promociones activas, ordenadas por prioridad ascendente. */
export const getActivePromotions = () =>
	promotions
		.filter((promotion) => promotion.activa)
		.sort((a, b) => a.prioridad - b.prioridad);

export default promotions;
